import styled from '@emotion/styled';
import React from 'react';

interface IPageProps {
  children: any;
  width?: 'M' | 'L' | 'XL' | number;
  className?: string;
  style?: any;
}

const Container = styled('div')`
  display: flex;
  justify-content: center;
  height: 100%;
`;

const BodyBase = styled('div')`
  flex: 1;
  height: 100%;
  width: 100%;
  padding-bottom: ${(p) => p.theme.spacing() * 2}px;
`;

const BodyM = styled(BodyBase)`
  max-width: 680px;
`;

const BodyL = styled(BodyBase)`
  max-width: 1160px;
`;

const BodyXL = styled(BodyBase)`
  max-width: 1500;
`;

const BodyCustom = styled(BodyBase)<{ width: number }>`
  max-width: ${(p) => p.width}px;
`;

export const Page = ({ width, className, style, children }: IPageProps) => (
  <Container>
    {typeof width === 'number' && (
      <BodyCustom className={className} style={style} width={width}>
        {children}
      </BodyCustom>
    )}
    {width === 'M' && (
      <BodyM className={className} style={style}>
        {children}
      </BodyM>
    )}
    {width === 'XL' && (
      <BodyXL className={className} style={style}>
        {children}
      </BodyXL>
    )}
    {(width === 'L' || !width) && (
      <BodyL className={className} style={style}>
        {children}
      </BodyL>
    )}
  </Container>
);
